<div class="form-group">
    <!-- Keep form value-change notifications for dependent-field rules without an editable control. -->
    <input type="hidden" [name]="'readOnlyField' + formField.id" [ngModel]="formField.value" />
    @if (formField.label) {
        <label class="form-element-label" for="form-element-{{ formField.id }}">{{ formField.label }}</label>
    }
    @switch (formField.type) {
        @case (fieldTypes.checkbox) {
            <input id="form-element-{{ formField.id }}" type="checkbox" [checked]="isChecked" disabled />
            <span class="ms-2">{{ formField.options?.checkboxSideLabel }}</span>
        }
        @case (fieldTypes.sendCopyToTheClientCheckbox) {
            <input id="form-element-{{ formField.id }}" type="checkbox" [checked]="isChecked" disabled />
        }
        @case (fieldTypes.sendFieldsToTheClientCheckbox) {
            <input id="form-element-{{ formField.id }}" type="checkbox" [checked]="isChecked" disabled />
        }
        @case (fieldTypes.message) {
            @if (formField.options?.isHtmlEditor === 'true') {
                <div id="form-element-{{ formField.id }}" class="form-control h-auto" [innerHTML]="displayValue"></div>
            } @else {
                <textarea
                    id="form-element-{{ formField.id }}"
                    class="form-control"
                    [value]="displayValue"
                    readonly></textarea>
            }
        }
        @case (fieldTypes.textArea) {
            <textarea
                id="form-element-{{ formField.id }}"
                class="form-control"
                [value]="displayValue"
                readonly></textarea>
        }
        @case (fieldTypes.date) {
            <input
                id="form-element-{{ formField.id }}"
                class="form-control"
                [value]="
                    dateValue !== null
                        ? (dateValue
                          | date: (formField.options?.isDateTime === 'true' ? 'dd.MM.yyyy HH:mm' : 'dd.MM.yyyy'))
                        : displayValue
                "
                readonly />
        }
        @case (fieldTypes.status) {
            <input
                id="form-element-{{ formField.id }}"
                class="form-control"
                [value]="+formField.value | ticketStatus"
                readonly />
        }
        @case (fieldTypes.attachment) {
            <div id="form-element-{{ formField.id }}" class="form-control h-auto">
                @for (attachment of attachments; track $index) {
                    <a class="d-block" [href]="attachment.url" target="_blank" rel="noopener noreferrer">{{
                        attachment.name
                    }}</a>
                }
                @if (!attachments.length) {
                    {{ displayValue }}
                }
            </div>
        }
        @default {
            <input id="form-element-{{ formField.id }}" class="form-control" [value]="displayValue" readonly />
        }
    }
</div>
